import { render, staticRenderFns } from "./WaitlistSummary.vue?vue&type=template&id=7784e2dc&"
import script from "./WaitlistSummary.vue?vue&type=script&lang=ts&"
export * from "./WaitlistSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./_locales/Waitlist.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2Fwaitlist%2FWaitlistSummary.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports